import { render, staticRenderFns } from "./customerTrail.vue?vue&type=template&id=7807fb36&scoped=true&"
import script from "./customerTrail.vue?vue&type=script&lang=js&"
export * from "./customerTrail.vue?vue&type=script&lang=js&"
import style0 from "./customerTrail.vue?vue&type=style&index=0&id=7807fb36&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7807fb36",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7807fb36')) {
      api.createRecord('7807fb36', component.options)
    } else {
      api.reload('7807fb36', component.options)
    }
    module.hot.accept("./customerTrail.vue?vue&type=template&id=7807fb36&scoped=true&", function () {
      api.rerender('7807fb36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/client/customer/detail/customerTrail.vue"
export default component.exports